module.exports = __webpack_public_path__ + "static/media/WM4@1.5x.3f8ad63f.png";